import { ActionTree } from 'vuex'
import State from './types'
import { RootState } from '../types'

export const actions: ActionTree<State, RootState> = {
  setTreeLoading({ commit }, { value }: { value: boolean }) {
    return new Promise<void>(resolve => {
      commit('setTreeLoading', { value })
      resolve()
    })
  },
}
